import { getToken } from 'firebase/app-check';
import { getAppCheck } from '../config/firebase-app-check-config';

/**
 * Aggiunge il token Firebase App Check agli header della richiesta
 * Equivalente del codice Flutter per gestire l'autenticazione con Firebase App Check
 */
export const addAppCheckToken = async (headers: Record<string, string> = {}): Promise<Record<string, string>> => {
    // Controlla se l'header è già presente e non vuoto
    if (!headers['X-Firebase-AppCheck'] || headers['X-Firebase-AppCheck'].trim() === '') {
        try {
            // Ottieni l'istanza di App Check
            const appCheck = getAppCheck();

            // Se App Check non è inizializzato, salta l'aggiunta del token
            if (!appCheck) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('Firebase App Check non disponibile - richiesta senza token');
                }
                return headers;
            }

            // Ottieni il token da Firebase App Check
            const appCheckTokenResponse = await getToken(appCheck, /* forceRefresh */ false);

            if (appCheckTokenResponse?.token) {
                // Aggiungi il token agli header
                headers['X-Firebase-AppCheck'] = appCheckTokenResponse.token;

                if (process.env.NODE_ENV === 'development') {
                    console.log(
                        `Firebase App Check token added to request: ${appCheckTokenResponse.token.substring(0, 20)}...`,
                    );
                }
            } else {
                if (process.env.NODE_ENV === 'development') {
                    console.log('Firebase App Check token is null - skipping in debug mode');
                } else {
                    console.warn('WARNING: Firebase App Check token is null in production mode');
                }
            }
        } catch (error) {
            if (process.env.NODE_ENV === 'development') {
                console.log('Firebase App Check error - skipping in debug mode:', error);
            } else {
                // In production, log ma non bloccare
                console.error('CRITICAL: Firebase App Check error in production:', error);
            }
        }
    }

    return headers;
};
